<template>
  <div class="app-page one-chat bulma-dropdown">
    <vue-headful title="ALICE | Activity Log"></vue-headful>
    <div class="column-wrapper">
      <div class="single-page-full">
        <div class="navbar-wrapper">
          <nav class="navbar no-padding" role="navigation">
            <div class="navbar-start">
              <div class="navbar-item">
                <label class="label title-label">Activity Log</label>
              </div>
            </div>
          </nav>
        </div>
        <div class="page-content">
          <div class="user-list w-100">
            <label for class="label sub-label p-2">
              <span>Activity Log&nbsp;</span>
              <span class="tag is-info is-rounded">{{ valueTotal }}</span>
            </label>
            <div class="flex-section section-table-activitylog">
              <div
                class="
                  bulma-dropdown
                  d-flex
                  justify-content-end
                  align-items-center
                  mb-3
                "
              >
                <b-dropdown id="date-filter" aria-role="list" position="is-bottom-left" class="float-right">
                  <div class="btn-link text-secondary" slot="trigger" role="button">
                    <font-awesome-icon class="text-primary-300 mr-1" icon="calendar" style="color: #dbdbdb"></font-awesome-icon>
                    {{ dateFilter.toUpperCase() }}
                    <i class="fa fa-angle-down ml-1"></i>
                  </div>
                  <b-dropdown-item aria-role="listitem" @click="toggleDateFilter('today')">
                    Today
                  </b-dropdown-item>
                  <b-dropdown-item aria-role="listitem" @click="toggleDateFilter('yesterday')">
                    Yesterday
                  </b-dropdown-item>
                  <b-dropdown-item aria-role="listitem" @click="toggleDateFilter('last7days')">
                    Last 7 days
                  </b-dropdown-item>
                  <b-dropdown-item aria-role="listitem" @click="toggleDateFilter('last28days')">
                    Last 28 days
                  </b-dropdown-item>
                  <b-dropdown-item aria-role="listitem" @click="toggleDateFilter('custom')">
                    Custom
                  </b-dropdown-item>
                </b-dropdown>
                <date-range-picker
                    v-show="dateFilter === 'custom'"
                    v-model="dateRange"
                    :ranges="false"
                    :show-dropdowns="true"
                    :maxDate="maxDate"
                    opens="left"
                    @update="toggleDateFilter('custom')"
                >
                  <div slot="input" slot-scope="picker">{{ formatDate(picker.startDate) }} - {{ formatDate(picker.endDate) }}</div>
                </date-range-picker>
              </div>
              <!-- <table class="table is-hoverable is-fullwidth">
                <colgroup>
                  <col span="1" style="width: 10%" />
                  <col span="1" style="width: 10%" />
                  <col span="1" style="width: 10%" />
                  <col span="1" style="width: 10%" />
                  <col span="1" style="width: 10%" />
                  <col span="1" style="width: 10%" />
                  <col span="1" style="width: 15%" />
                  <col span="1" style="width: 11%" />
                </colgroup>
                <thead>
                  <tr>
                    <th>
                      <div class="field is-grouped">
                        <div class="control is-expanded has-icons-left">
                          <input
                            class="input is-small"
                            type="text"
                            placeholder="Filter Scope"
                            v-model="beforeSearchInput"
                          />
                          <span class="icon is-small is-left">
                            <font-awesome-icon
                              icon="filter"
                            ></font-awesome-icon>
                          </span>
                        </div>
                      </div>
                    </th>
                    <th>
                      <div class="field is-grouped">
                        <div class="control is-expanded has-icons-left">
                          <input
                            class="input is-small"
                            type="text"
                            placeholder="Filter Scope"
                            v-model="beforeSearchInput"
                          />
                          <span class="icon is-small is-left">
                            <font-awesome-icon
                              icon="filter"
                            ></font-awesome-icon>
                          </span>
                        </div>
                      </div>
                    </th>
                    <th>
                      <div class="field is-expanded has-addons">
                        <div class="control is-expanded has-icons-left">
                          <input
                            type="text"
                            class="input is-small"
                            placeholder="Add new rule"
                            v-model="newRuleTextInput"
                          />
                          <span class="icon is-small is-left">
                            <font-awesome-icon
                              icon="search"
                            ></font-awesome-icon>
                          </span>
                        </div>
                      </div>
                    </th>
                    <th>
                      <div class="field is-expanded has-addons">
                        <div class="control is-expanded has-icons-left">
                          <input
                            type="text"
                            class="input is-small"
                            placeholder="Add new rule"
                            v-model="newRuleTextInput"
                          />
                          <span class="icon is-small is-left">
                            <font-awesome-icon
                              icon="search"
                            ></font-awesome-icon>
                          </span>
                        </div>
                      </div>
                    </th>
                    <th>
                      <div class="field is-grouped">
                        <div class="control is-expanded has-icons-left">
                          <input
                            class="input is-small"
                            type="text"
                            placeholder="Filter Scope"
                            v-model="beforeSearchInput"
                          />
                          <span class="icon is-small is-left">
                            <font-awesome-icon
                              icon="filter"
                            ></font-awesome-icon>
                          </span>
                        </div>
                      </div>
                    </th>
                    <th>
                      <div class="field is-expanded has-addons">
                        <div class="control is-expanded has-icons-left">
                          <input
                            type="text"
                            class="input is-small"
                            placeholder="Add new rule"
                            v-model="newRuleTextInput"
                          />
                          <span class="icon is-small is-left">
                            <font-awesome-icon
                              icon="search"
                            ></font-awesome-icon>
                          </span>
                        </div>
                      </div>
                    </th>
                    <th>
                      <div class="field is-expanded has-addons">
                        <div class="control is-expanded has-icons-left">
                          <input
                            type="text"
                            class="input is-small"
                            placeholder="Add new rule"
                            v-model="newRuleTextInput"
                          />
                          <span class="icon is-small is-left">
                            <font-awesome-icon
                              icon="search"
                            ></font-awesome-icon>
                          </span>
                        </div>
                      </div>
                    </th>
                    <th></th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="data in datashow" :key="data.id">
                    <td>{{ data.scope }}</td>
                    <td>{{ data.type }}</td>
                    <td>{{ data.user_id }}</td>
                    <td>{{ data.user_email }}</td>
                    <td>{{ data.user_role }}</td>
                    <td>{{ data.username }}</td>
                    <td>{{ data.data }}</td>
                    <td>{{ data.created_at }}</td>
                  </tr>
                </tbody>
              </table> -->
              <VueTabulator ref="tabulator" v-model="datashow" :options="options" class="tableactivitylog" />
              <div class="pagination-wrapper d-flex justify-content-end p-3">
                <input class="mr-2" type="number" :value="valuePageSize" @input="updateValue" :max="100" :min="1"/>
                <b-pagination
                  :total="valueTotal"
                  v-model="valuePage"
                  :size="'is-small'"
                  :per-page="valuePageSize"
                  first-text="First"
                  prev-text="Prev"
                  next-text="Next"
                ></b-pagination>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script src="https://code.jquery.com/jquery-3.3.1.slim.min.js"></script>
<script>
import moment from 'moment';
import { DateTime } from 'luxon';
import alice from '../../alice-api';

export default {
  name: 'activitylog',
  data() {
    return {
      maxDate: moment().toISOString(),
      valuePage: 1,
      valuePageSize: 20,
      valueTotal: '',
      dateFilter: 'last28days',
      dateRange: {
        startDate: moment()
          .startOf('day')
          .toISOString(),
        endDate: moment()
          .endOf('day')
          .toISOString(),
      },
      datashow: [],
      datasort: [],
      filterscope: '',
      filteruserId: '',
      filterusername: '',
      filteremail: '',
      fitertime: {},
      options: {
        layout: 'fitColumns',
        maxHeight: '100%',
        placeholder: 'No data',
        reactiveData: true,
        columnMinWidth: 80,
        headerFilter: true,
        headerSort: true,
        nestedFieldSeparator: '|',
        groupToggleElement: 'arrow',
        columns: [
          {
            title: 'SCOPE',
            field: 'scope',
            formatter: 'select',
            headerFilterPlaceholder: 'select scope',
            headerFilter: true,
            headerFilterParams: {
              values: {
                ISSUE: 'Issue',
                MODEL: 'Model',
                MODEL_CATEGORY: 'Model Category',
                MODEL_QUESTION: 'Model Question',
                RULE_SET: 'Rule Set',
                RULE_BASED: 'Rule Based',
                NLP_CONFIG: 'NLP Conflg',
                ONE_ON_ONE_CHAT: 'One On One chat',
                KEY_VALUE_COLLECTION: 'Key value collection',
                KEY_VALUE_ENTRY: 'Key value entry',
                PROMOTIONS: 'Promotions',
                USER_MANAGER: 'User Manager',
              },
              sorter: () => {
                return null;
              },
            },
            headerFilterEmptyCheck: (value) => {
              if (value.length != 0 && this.filterscope != value) {
                this.filterscope = [];
                this.filterscope = value;
                this.calldataactivity();
              } else if (value.length == 0 && this.filterscope != value) {
                this.filteruserId = '';
                this.calldataactivity();
              }
              return value;
            },
          },
          {
            title: 'USER EMAIL',
            field: 'user_email',
            headerFilterPlaceholder: 'input user email',
            headerFilter: true,
            headerFilterEmptyCheck: (value) => {
              if (value.length != 0 && this.filteremail != value) {
                this.filteremail = [];
                this.filteremail = value;
              } else if (value.length == 0) {
                this.filteremail = '';
              }
              this.calldataactivity();
              return value;
            },
            sorter: () => {
              return null;
            },
          },
          {
            title: 'USERNAME',
            field: 'username',
            headerFilterPlaceholder: 'input username',
            headerFilter: true,
            headerFilterEmptyCheck: (value) => {
              if (value.length != 0 && this.filterusername != value) {
                this.filterusername = [];
                this.filterusername = value;
              } else if (value.length == 0) {
                this.filterusername = '';
              }
              this.calldataactivity();
              return value;
            },
            sorter: () => {
              return null;
            },
          },
          {
            title: 'USER ROLE',
            field: 'user_role',
            sorter: () => {
              return null;
            },
          },
          {
            title: 'DESCRIPTION',
            field: 'data|description',
            headerSort: false,
          },
          {
            title: 'CREATED AT',
            field: 'created_at',
            sorter: () => {
              return null;
            },
          },
        ],
      },
    };
  },
  watch: {
    valuePage: {
      handler: 'calldataactivity',
    },
  },
  mounted() {
    const obj = {};
    obj.untilDate = moment()
      .utcOffset(420)
      .endOf('day')
      .toISOString();
    obj.sinceDate = moment()
      .utcOffset(420)
      .subtract(27, 'days')
      .startOf('day')
      .toISOString();
    obj.granularity = 'day';
    this.fitertime = obj;
    this.calldataactivity();
    $(document).ready(() => {
      $('.tableactivitylog .tabulator-sortable').click(
        function(element) {
          const obj = {};
          let elementasc = document.querySelectorAll('.tabulator-sortable[aria-sort=asc]').length;
          let elementdesc = document.querySelectorAll('.tabulator-sortable[aria-sort=desc]').length;
          if (elementasc + elementdesc === 1) {
            this.datasort = [];
          }
          const field = $(element.currentTarget.attributes['tabulator-field'])[0].value;
          const foundIndex = this.datasort.findIndex((element) => element.field == field);
          const sort = $(element.currentTarget.attributes['aria-sort'])[0].value.toUpperCase();
          if (this.datasort[foundIndex]) {
            this.datasort[foundIndex].direction = sort;
          } else {
            obj.field = field;
            obj.direction = sort;
            this.datasort.push(obj);
          }
          this.calldataactivity();
        }.bind(this),
      );
      // $('.tabulator-header-filter #text-field-container #search-clear').click( function(element) {
      //   console.log("test");
      // });
    });
  },
  methods: {
    formatDate(str) {
      return moment(str).format('ll');
    },
    toggleDateFilter(value) {
      this.dateFilter = value;
      this.fitertime = {};
      const obj = {};
      obj.untilDate = moment()
        .utcOffset(420)
        .endOf('day')
        .toISOString();
      if (this.dateFilter === 'today') {
        obj.sinceDate = moment()
          .startOf('day')
          .toISOString();
        obj.granularity = 'hour';
      } else if (this.dateFilter === 'yesterday') {
        obj.sinceDate = moment()
          .subtract(1, 'days')
          .startOf('day')
          .toISOString();
        obj.untilDate = moment()
          .subtract(1, 'days')
          .endOf('day')
          .toISOString();
        obj.granularity = 'hour';
      } else if (this.dateFilter === 'last7days') {
        obj.sinceDate = moment()
          .utcOffset(420)
          .subtract(6, 'days')
          .startOf('day')
          .toISOString();
        obj.granularity = 'day';
      } else if (this.dateFilter === 'last28days') {
        obj.sinceDate = moment()
          .utcOffset(420)
          .subtract(27, 'days')
          .startOf('day')
          .toISOString();
        obj.granularity = 'day';
      } else if (this.dateFilter === 'custom') {
        obj.untilDate = moment(this.dateRange.endDate)
          .utcOffset(420)
          .endOf('day');
        obj.sinceDate = moment(this.dateRange.startDate)
          .utcOffset(420)
          .startOf('day');
        const since = moment(obj.sinceDate);
        const until = moment(obj.untilDate);
        const diff = until.diff(since, 'days', true);
        if (diff <= 1) obj.granularity = 'hour';
        else if (diff <= 31) obj.granularity = 'day';
        else obj.granularity = 'month';
      }
      this.fitertime = obj;
      this.calldataactivity();
    },
    calldataactivity() {
      const arraysort = {
        page: this.valuePage - 1,
        size: this.valuePageSize,
      };
      this.datasort.length != 0 ? (arraysort['sort'] = this.datasort) : null;
      this.filterscope ? (arraysort['scope'] = [this.filterscope]) : null;
      this.filteruserId ? (arraysort['userId'] = [this.filteruserId]) : null;
      this.filterusername ? (arraysort['username'] = [this.filterusername]) : null;
      this.filteremail ? (arraysort['email'] = [this.filteremail]) : null;
      this.fitertime.length != 0 ? (arraysort['time'] = this.fitertime) : null;
      // console.log(arraysort);
      alice.activityLog(arraysort).then((result) => {
        this.valueTotal = result.data.data.totalElements;
        this.datashow = result.data.data.content;
        this.datashow = this.datashow.map((data) => {
          data.created_at = DateTime.fromISO(data.created_at)
            .setZone('Asia/Bangkok')
            .toFormat('dd/LL/yyyy HH:mm:ss');
          return data;
        });
        // console.log(this.datashow);
      });
    },
    updateValue(event) {
      const value = event.target.value;
      if (value <= 100 && value > 0) {
        this.valuePageSize = value;
      }
      this.calldataactivity()
      this.$forceUpdate()
    }
  },
};
</script>
<style>
.section-table-activitylog {
  display: flex;
  flex-direction: column;
  flex-wrap: nowrap;
  max-height: calc(100% - 100px);
  min-height: 300px;
}
.tableactivitylog input[type='search']::-webkit-search-cancel-button {
  display: none;
}
.tabulator-header .tabulator-col input {
  color: #000 !important;
}
.pagination .pagination-next,
.pagination .pagination-previous {
  display: none;
}
.table.is-fullwidth {
  margin-bottom: 0px;
}
.table.is-fullwidth th {
  text-transform: uppercase;
}
.icon.issort {
  color: #2196f3;
}
.pagination-link.is-current {
  background-color: #2196f3;
  border-color: #2196f3;
  color: #fff;
}
.tabulator-header .tabulator-col input {
  border: 1px solid #dbdbdb;
  border-radius: 2px;
  background: #fff;
  color: #fff;
  outline: none;
}
.tableactivitylog .tabulator-header {
  border-top: 2px solid #ddd;
}
</style>
